module.exports = __webpack_public_path__ + "static/media/google.fa449af0.svg";